<template>
  <div class="middleBox">
    <div class="HeaderBox"><Header></Header></div>
    <div class="sideContent">
      <!-- <div class="box">123</div>
      <div class="box">123</div>
      <div class="box">123</div> -->
      <!-- <keep-alive> -->
        <component :is="contentList[comname]" @goChat="goChat"></component>
      <!-- </keep-alive> -->
    </div>
  </div>
</template>

<script>
import Header from './+components/Header';
import Chats from './chats';
import ChatHistory from './chatHistory';
import Favorite from './favorite';
import Quota from './quota';
import Settings from './settings';
import Agent from './agent';
import Notification from './notification';
import {mapState, mapMutations} from 'vuex';
export default {
  name: '',
  components: { Header },
  props: {
    // comname: {
    //   type: String
    // }
  },
  data () {
    return {
      contentList: {
        Chats, ChatHistory,Favorite, Quota, Settings, Agent, Notification
      },
    }
  },
  computed: {
    ...mapState('comAbout', {comname: 'componentName'}),
  },
  watch: {},
  created () {},
  mounted () {
  },
  methods: {
    // ...mapMutations('comAbout', ['changeComponentName']),
    // 切换功能页面
    // changeContent(comName) {
    //   this.contents = comName;
    // }
    // changeCom(comName) {
    //   this.$emit('changeAction', comName);
    // },
    // 展开聊天
    goChat(){
      this.$emit('goChat');
    }
  }
}
</script>

<style scoped lang="less">
.middleBox {
  display: flex;
  flex-direction: column;
  // height: 100vh;
  height: 100%;
  .HeaderBox {
    height: 84px;
  }
  .sideContent {
    padding: 0 30px 30px;
    flex: 1;
    // height: calc(100vh - 84px);
    height: calc(100% - 84px);
  }
}

</style>
